export const catalog = {
  catalogSearchInputPlaceholderTitle: 'Search',
  catalogHeaderTitle: 'Details',
  catalogDetailsCurtainCopyOptionTitle: 'Copy link',
  catalogDetailsLinkCopiedAlertText: 'Link copied!',
  catalogDetailsCurtainFlagOptionTitle: 'Flag content',
  catalogDetailsFlagCurtainTitle: 'Flag',
  catalogReportedCurtainContent: 'Content reported',
  catalogWantBuy: 'Want to buy {item} from {app}',
  catalogInterestedIn: '{link}'
}
